export default class AssignStudentController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, groups, moment
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.groups = groups;
    this.moment = moment;

    this.selectedGroup = {};
    this.date = new Date();
  }

  assignStudent(form) {
    if (form.$invalid) {
      return true;
    }

    const formatDate = this.moment(this.date).format('YYYY-MM-DD');
    this.$mdDialog.hide({groupId: this.selectedGroup, date: formatDate});
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
